import React from 'react';
import { PillBadgeStyled } from './pill-badge.component.style';
export var PillBadge = function (_a) {
    var children = _a.children;
    return React.createElement(PillBadgeStyled, null, children);
};
